import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { ICurrentUser } from "../@types";
import CurrentUserURI from "./CurrentUserURIBuilder";

export interface IFetchUserOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
}

export const createRequest = (opts: IFetchUserOpts): Request => {
  const { apiUrl, apikey, ...restOpts } = opts;
  const url = new CurrentUserURI().setApiUrl(apiUrl).setSegment(["user"]);

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
    "Content-type": "application/json",
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };

  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }
  return new Request(String(url), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function fetchUser(opts: IFetchUserOpts): Promise<JsonQuery<IResultstash<ICurrentUser>>> {
  return await fetchJsonQuery<IResultstash<ICurrentUser>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default fetchUser;
